import { HandlersCollection, Ref, RefNumber, RefString } from "@tblabs/truffle";
import { BasketItemType } from "../../Models/Basket/BasketItemType";
import { Product } from "../../Models/Product/Product";
import { Discounter } from "./Discounter";
import { BasketStorageItem } from "./Storage/BasketStorageItem";


export abstract class BasketItem
{
    protected onChangeHandlers = new HandlersCollection<() => void>();

    public OnChange(handler: () => void)
    {
        this.onChangeHandlers.Add(handler);
    }

    public abstract UpdateOnInputChange();
    public abstract AsRaw(): BasketStorageItem | undefined;

    // Input:
    public readonly Type: BasketItemType;
    public readonly Product: Product | undefined;
    public readonly ProductOptionId: Ref<string>;
    public readonly Quantity: Ref<number>;
    public readonly Discounter: Discounter;

    // Output:
    public FinalPriceBeforeDiscount = new RefNumber();
    public FinalPriceAfterDiscount = new RefNumber();
    public Label = new RefString(); // Np. "Wypożyczenie na 4 dni" lub "Zakup"
    public QuantityDiscountPercent = new RefNumber();
    public ExtraInfo = new RefString();

    constructor(type: BasketItemType, product: Product | undefined, productOptionId: Ref<string>, quantity: Ref<number>, discount: Discounter)
    {
        this.Type = type;
        this.Product = product;
        this.ProductOptionId = productOptionId;
        this.Quantity = quantity;
        this.Discounter = discount;

        if (!this.Product)
            this.Product = new Product();

        productOptionId.OnChange(optionId => this.UpdateOnInputChange());
        quantity.OnChange(quantity => this.UpdateOnInputChange());
        discount.OnChange(() => this.UpdateOnInputChange());
    }

    public GetOptionNameById(id: string): string
    {
        if (!this.Product)
            return "";

        return this.Product.Options.List.Items.find(x => x.Url.value == id)?.Label.value || "";
    }
}
